import { VisibilityLevels } from '../constants'
import communicationApi from '@app/application/communication/sections/communication/api'

export default {
  computed: {
    isTodo() {
      return this.type === 'todo'
    },
    isCurrentPeriodChosenForVisibility() {
      return this.visibility === VisibilityLevels.currentPeriod
    },
    isPinnedChosenForVisibility() {
      return this.visibility === VisibilityLevels.pinned
    },
    isRecurringChosenForVisibility() {
      return this.visibility === VisibilityLevels.recurring
    },
    showPeriodSelector() {
      return !this.hidePeriodSelector && !window.Silverfin.isCurrentUserPulse()
    },
    addAttachmentMessage() {
      return `<span class="sf-pointer sf-a">
                ${I18n.t('communication.remark_form.add_attachments')}
                <span><span class="icon icon-paperclip sf-c-text"></span></span>
              </span>`
    },
    visibilityExplainLabel() {
      if (this.isCurrentPeriodChosenForVisibility) {
        return ''
      }

      if (this.endLedgerLabel) {
        return I18n.t('communication.remark_form.from_to', {
          start: this.ledgerLabel,
          end: this.endLedgerLabel,
        })
      } else {
        return I18n.t('communication.remark_form.from', {
          start: this.ledgerLabel,
        })
      }
    },
    uploadInProgress() {
      return this.uploadProgress > 0 && this.uploadProgress < 100
    },
  },
  methods: {
    setTodo() {
      this.type = 'todo'
    },
    updateUploadProgress({ progress }) {
      this.uploadProgress = progress
    },
    changeVisibility(newVisibility) {
      this.visibility = newVisibility
    },
    close() {
      this.modalOpen = false
    },
    setMentionableUsernames() {
      communicationApi
        .getMentionUsernames({ companyId: this.companyId })
        .then((data) => {
          this.mentionUsernames = data
        })
    },
  },
}
